import { render } from "./Wizard.vue?vue&type=template&id=c048bfd2&scoped=true"
import script from "./Wizard.vue?vue&type=script&lang=js"
export * from "./Wizard.vue?vue&type=script&lang=js"

import "./Wizard.vue?vue&type=style&index=0&id=c048bfd2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c048bfd2"]])

export default __exports__